<template>
  <div class="reportPage-div">
    <div class="search-div">
        <InputEl v-model:lableValue="InputEllableValue" 
            v-model="InputElValue"  class="select-kongjian-dom"></InputEl>
        <SelectEI v-model:lableValue="SelectEIlableValue" 
            v-model:options="selectDataList" v-if="status == '统计'"
            v-model="SelectEIValue" class="select-kongjian-dom"></SelectEI>
        <el-button type="primary" @click="cleanInput">重置</el-button>
        <el-button type="primary" @click="addData">新增</el-button>
        <el-button type="primary" @click="searchData">搜索</el-button>
    </div>
    <div class="list-data-div">
         <el-table :data="listData" border fit 
            :header-cell-style="{ textAlign: 'center' }" 
            style="width: 100%;height: 100%;" stripe>
            <!-- 使用 v-for 渲染普通列 -->
            <el-table-column v-for="col in status=='统计' ? columnsT : columns"
                :key="col.prop" :prop="col.prop"
                :label="col.label" :width="col.width"
                :fixed="col.fixed" v-bind="getDynamicProps(col)">
            </el-table-column>
            <!-- 单独处理“操作”列 -->
            <el-table-column align='center' v-if="status!='统计'" fixed="right" label="操作" width="300">
                <template v-slot="scope">
                    <el-button @click="listDataHandle(scope.row)" type="text" size="small">查看</el-button>
                    <el-button type="text" size="small" 
                        v-if="judgmentDistTORF(scope.row, 'types', ['待处理', '已撤回'])" 
                        @click="listDataHandleEdit(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" 
                        v-if="judgmentDistTORF(scope.row, 'types', ['待处理', '已撤回'])" 
                        @click="listDataHandleDelete(scope.row)">删除</el-button>
                    <el-button type="text" size="small" 
                        v-if="judgmentDistTORF(scope.row, 'types', ['待处理', '已撤回'])" 
                        @click="listDataHandleRelease(scope.row)">发布</el-button>
                    <el-button type="text" size="small" 
                        v-if="judgmentDistTORF(scope.row, 'types', '审核中')" 
                        @click="listDataHandleWithdraw(scope.row)">撤回</el-button>
                    <el-button type="text" size="small" 
                        v-if="judgmentDistTORF(scope.row, 'types', '审核中')" 
                        @click="listDataHandleAudit(scope.row)">审核</el-button>
                </template>
            </el-table-column>
            <el-table-column align='center'  v-if="status=='统计'" fixed="right" label="操作" width="80">
                <template v-slot="scope">
                    <el-button @click="listDataHandle(scope.row)" type="text" size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>

    <ModalEI v-if="showModal" v-model:visible="showModal" 
    v-model:titleValue="titleValue" @close="showModal = false">
      <reportEditPage
        :data="currentData"
        :is-view="isViewMode"
        @save="onEditSave"
        @close="showModal = false"
      />
    </ModalEI>
  </div>
</template>

<script>
// 申报
export default {
  name: 'reportPage',
  props: {
    status: {
        type: String,
        required: false,
        default: ''
    }
  },
  data() {
    return {
        dataLists: [
            { "info": "", "types": "待处理", "value": "三全鲜食（北新泾店）", "address": "长宁区新渔路144号" },
            { "info": "地址误差", "types": "审核不通过", "value": "Hot honey 首尔炸鸡（仙霞路）", "address": "上海市长宁区淞虹路661号" },
            { "info": "", "types": "待处理", "value": "新旺角茶餐厅", "address": "上海市普陀区真北路988号创邑金沙谷6号楼113" },
            { "info": "", "types": "审核中", "value": "泷千家(天山西路店)", "address": "天山西路438号" },
            { "info": "", "types": "审核中", "value": "胖仙女纸杯蛋糕（上海凌空店）", "address": "上海市长宁区金钟路968号1幢18号楼一层商铺18-101" },
            { "info": "", "types": "审核中", "value": "贡茶", "address": "上海市长宁区金钟路633号" },
            { "info": "", "types": "待处理", "value": "豪大大香鸡排超级奶爸", "address": "上海市嘉定区曹安公路曹安路1685号" },
            { "info": "", "types": "已上架", "value": "茶芝兰（奶茶，手抓饼）", "address": "上海市普陀区同普路1435号" },
            { "info": "", "types": "已上架", "value": "十二泷町", "address": "上海市北翟路1444弄81号B幢-107" }],
        selectDataList: [{"label": "待处理", "value": "待处理"}, 
            {"label": "审核中", "value": "审核中"}, 
            {"label": "已上架", "value": "已上架"},
            {"label": "已撤回", "value": "已撤回"},
            {"label": "审核不通过", "value": "审核不通过"}],
        listData: [],
        showModal: false,
        titleValue: "",
        currentData: {},
        isViewMode: false,
        InputElValue: "",
        InputEllableValue: "名称",
        SelectEIlableValue: "状态",
        SelectEIValue: "",
        // 列配置信息
        columns: [
            { prop: 'value', label: '名称', minWidth: '120', fixed: true, width: ''},
            { prop: 'address', label: '地址', minWidth: '150', width: ''},
            { prop: 'types', label: '状态', width: '80', minWidth: ''}
        ],
        columnsT: [
            { prop: 'value', label: '名称', minWidth: '100', fixed: true, width: ''},
            { prop: 'address', label: '地址', minWidth: '120', width: ''},
            { prop: 'info', label: '审核说明', minWidth: '150', width: ''},
            { prop: 'types', label: '状态', width: '100', minWidth: ''}
        ]
    };
  },
  methods: {
    cleanInput() {
        console.log("清除");
        this.InputElValue = "";
        this.SelectEIValue = "";
        this.searchData();
    },
    addData() {
        this.titleValue = "新增";
        this.currentData = {"models":"新增"};
        this.isViewMode = false;
        this.showModal = true;
    },
    searchData() {
        console.log("搜索");
        this.getData();
    },
    getData(){
        console.log("获取数据");
        var savedData = localStorage.getItem('reportPageListDataInfo');
        if (savedData) {
            this.dataLists = JSON.parse(savedData);
        }else{
            localStorage.setItem('reportPageListDataInfo', JSON.stringify(this.dataLists));
        }
        if (this.status == "统计"){
            this.listData = this.dataLists.filter((item) => {
                return (this.InputElValue != "" ? item.value.includes(this.InputElValue) : true) && 
                (this.SelectEIValue != "" ? item.types == this.SelectEIValue : true);
            });
        }else if (this.status == "审核中"){
            this.listData = this.dataLists.filter((item) => {
                return (this.InputElValue != "" ? item.value.includes(this.InputElValue) : true) && 
                (item.types == '审核中');
            });
        }else{
            this.listData = this.dataLists.filter((item) => {
                return (this.InputElValue != "" ? item.value.includes(this.InputElValue) : true) && 
                (item.types == '待处理' || item.types == '已撤回');
            });
        }
    },
    InputElValueUpdate(NewValue) {
        this.InputElValue = NewValue;
        console.log("值改变", this.InputElValue, NewValue);
    },
    SelectEIValueUpdate(NewValue) {
        this.SelectEIValue = NewValue;
        console.log("值改变", this.SelectEIValue, NewValue);
    },
    /**
     * 
     * @param { Object } dist 传入的字典
     * @param { String } keyValue 字典对应key键
     * @param { * } value 判断的值，接受列表传入
     */
    judgmentDistTORF(dist, keyValue, value) {
        if (typeof(dist) != "object"){
            this.$messageX.xiaoxiti("f", "系统运行出现错误！tip【传入值dist错误！】");
            return false;
        }
        if (typeof(keyValue) != "string"){
            this.$messageX.xiaoxiti("f", "系统运行出现错误！tip【传入值keyValue错误！】");
            return false;
        }
        if (typeof(value) == 'object'){
            if (value.includes(dist[keyValue])){
                return true;
            }else{
                return false;
            }
        }else{
            if (dist[keyValue] == value){
                return true;
            }else{
                return false;
            }
        }
        
    },
    listDataHandle(item) {
        // 打开编辑界面进行查看
        this.titleValue = "查看";
        this.currentData = {...item, "models":"查看"};
        this.isViewMode = true;
        this.showModal = true;
    },
    listDataHandleEdit(item) {
        // 打开编辑界面进行编辑
        this.titleValue = "编辑";
        this.currentData = {...item, "models":"编辑"};
        this.isViewMode = false;
        this.showModal = true;
    },
    listDataHandleDelete(item) {
        // 弹出确认窗口，提示是否删除
        console.log(item);
        this.$messageX.tipWin({"magess":"确定删除？", "magess_title":"提示",...item}, this.HandleDelete, this.emptyFunction);
    },
    listDataHandleRelease(item) {
        // 弹出确认窗口，提示是否发布
        console.log(item);
        this.$messageX.tipWin({"magess":"确定发布？", "magess_title":"提示",...item}, this.HandleRelease, this.emptyFunction);
    },
    listDataHandleWithdraw(item) {
        // 弹出确认窗口，提示是否撤回
        console.log(item);
        this.$messageX.tipWin({"magess":"提示是否撤回？", "magess_title":"提示",...item}, this.HandleWithdraw, this.emptyFunction);
    },
    listDataHandleAudit(item) {
        // 打开编辑界面，只展示数据，最下方有【审核通过】【审核不通过】按钮
        // 单击通过弹出确认窗口，提示通过后会同步上架，是否通过
        // 单击通过弹出确认窗口，提示审核不通过后会同步撤回，是否撤回
        this.titleValue = "审核";
        this.currentData = {...item, "models":"审核"};
        this.isViewMode = true;
        this.showModal = true;
    },
    getDynamicProps(col) {
      const props = {};
      if (col.minWidth) {
        props['min-width'] = col.minWidth;
      }
      return props;
    },
    onEditSave(formData) {
        console.log("父组件拿到数据", formData);
        if (formData.models == '新增'){
            let ls = { "info": "", "types": formData.types, "value": formData.value, "address": formData.address };
            let qc = this.dataLists.filter((item) => {
                return item.value == formData.value;
            });
            if (qc.length > 0){
                this.$messageX.xiaoxiti("f", "新增失败！已存在当前店铺信息！");
            }else{
                this.dataLists.push(ls);
            }
        }else{
            if (formData.models == '编辑'){
                let qc = this.dataLists.filter((item) => {
                    return item.value == formData.value;
                });
                if (qc.length > 0){
                    this.$messageX.xiaoxiti("f", "修改失败！已存在修改后相同的店铺信息！");
                    this.showModal = false;
                    return false;
                }
            }
            this.dataLists = this.dataLists.map((items) => {
                items.value == formData.value ? items.types = formData.types : items;
                items.value == formData.value ? (formData.info ? items.info = formData.info : items) : items;
                return items;
            });
        }
        this.showModal = false
        localStorage.setItem('reportPageListDataInfo', JSON.stringify(this.dataLists));
        this.getData();
    },
    emptyFunction() {

    },
    HandleDelete(item) {
        let index = this.dataLists.findIndex(items => items.value === item.value);
        if (index !== -1) {
            // 如果找到了，则删除该元素
            this.dataLists.splice(index, 1);
        }else{
            this.$messageX.xiaoxiti("f", "系统运行出现错误！tip【未找到数据！】");
        }
        localStorage.setItem('reportPageListDataInfo', JSON.stringify(this.dataLists));
        this.getData();
    },
    HandleRelease(item) {
        this.dataLists = this.dataLists.map((items) => {
            items.value == item.value ? items.types = '审核中' : items;
            return items;
        });
        localStorage.setItem('reportPageListDataInfo', JSON.stringify(this.dataLists));
        this.getData();
    },
    HandleWithdraw(item) {
        this.dataLists = this.dataLists.map((items) => {
            items.value == item.value ? items.types = '已撤回' : items;
            return items;
        });
        localStorage.setItem('reportPageListDataInfo', JSON.stringify(this.dataLists));
        this.getData();
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style scoped>
.reportPage-div {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    background-color: white;
}

.search-div {
    width: 100%;
    height: 65px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    align-content: center;
    padding-right: 20px;
}

.list-data-div {
    width: 100%;
    height: calc(100% - 65px);
    display: flex;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 15px;
}

.select-kongjian-dom {
    width: 180px;
}
</style>



